import { render } from "./Ordertype.vue?vue&type=template&id=7ffb983d&scoped=true"
import script from "./Ordertype.vue?vue&type=script&lang=js"
export * from "./Ordertype.vue?vue&type=script&lang=js"

import "./Ordertype.vue?vue&type=style&index=0&id=7ffb983d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ffb983d"]])

export default __exports__